import React from 'react';
import { Button, MobileStepper, Stack, Typography } from '@mui/material';
import { useCampaign, useCampaignForm, useIsMobile } from 'hooks';
import { CampaignFormInputs } from 'types';
import { getFormattedDateTime } from 'utils';
import { orderedSteps, stepIndices } from 'shared';

type CampaignStepperControlsProps = {
  onSubmit: (data: CampaignFormInputs) => void;
};

export const CampaignStepperControls = ({ onSubmit }: CampaignStepperControlsProps) => {
  const {
    goToNextStep,
    goToPrevStep,
    control: { handleSubmit },
    activeStep,
    isLastStep,
  } = useCampaignForm();
  const { getCampaignQuery } = useCampaign();
  const { isMobile } = useIsMobile();

  const campaign = getCampaignQuery.data?.campaign;

  const campaignUpdatedTime = getFormattedDateTime(campaign?.updatedAt);

  const handleNext = isLastStep ? handleSubmit(onSubmit) : () => goToNextStep();

  const nextButtonLabel = isLastStep ? (isMobile ? 'Bestellen' : 'Kostenpflichtig bestellen') : 'WEITER';

  return (
    <Stack direction="row" justifyContent="space-between">
      {/* Stack needs to be rendered to follow markup */}
      <Stack display={{ md: 'block', xs: 'none' }}>
        {campaignUpdatedTime ? (
          <>
            <Typography variant="h5">Automatisch gespeichert:</Typography>
            <Typography variant="body2">{campaignUpdatedTime}</Typography>
          </>
        ) : null}
      </Stack>
      <Stack direction="row" spacing={5} justifyContent="flex-end" sx={{ display: { xs: 'none', sm: 'flex' } }}>
        <Button variant="outlined" onClick={goToPrevStep}>
          ZURÜCK
        </Button>
        <Button variant="contained" onClick={handleNext}>
          {nextButtonLabel}
        </Button>
      </Stack>
      <MobileStepper
        variant="dots"
        steps={orderedSteps.length}
        position="static"
        activeStep={stepIndices[activeStep]}
        sx={{ maxWidth: 400, flexGrow: 1, gap: 2.5, display: { xs: 'flex', sm: 'none' } }}
        backButton={<Button onClick={goToPrevStep}>ZURÜCK</Button>}
        nextButton={<Button onClick={handleNext}>{nextButtonLabel}</Button>}
      />
    </Stack>
  );
};
